/**
 * 檔案用途區塊
 * @module ZaloSsoPage
 * @purpose 組合內容版型與 Zalo 登入元件，作為 Zalo SSO 入口頁面。
 * @external https://innotech.atlassian.net/browse/IN-40532
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import ZaloLogin from '@modules/zalo/components/ZaloLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description ZaloSsoPage 頁面元件。
 * @purpose 渲染帶有 testId 的 ContentLayout，並於其中承載 ZaloLogin 登入流程。
 * @external https://innotech.atlassian.net/browse/IN-40532
 */
const ZaloSsoPage = () => {
  return (
    <ContentLayout testId="ZaloSsoPage">
      <ZaloLogin />
    </ContentLayout>
  );
};

export default ZaloSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:19:47.090Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotations (top/middle/bottom) with mandated titles and tags, mapped declaration to IN-40532 using full Jira URL, and kept runtime logic unchanged.
 */
